export const EMAIL_FILE_EXTENSIONS = [".eml", ".msg"];

export const EMAIL_UPLOAD_ACCEPT = EMAIL_FILE_EXTENSIONS.join(",");

export const EMAIL_DROPZONE_ACCEPT = {
	"message/rfc822": [".eml"],
	"application/vnd.ms-outlook": [".msg"],
};
